import React from 'react';
import { SettingsPayment } from 'features/SettingsPayment/settings-payment';

export function MembershipTab({ user }) {
  return <SettingsPayment user={user} />;
}
